import {CommonModule} from '@angular/common';
import {Component, ContentChild, Input, ViewEncapsulation} from '@angular/core';
import {FormsModule, NgControl} from '@angular/forms';
import {MatCheckboxChange, MatCheckboxModule} from '@angular/material/checkbox';
import {DynamicFormControl} from '@q9elements/ui-kit/changes/shared';

@Component({
  selector: 'q9ma-checkbox-wrapper',
  standalone: true,
  host: {
    '[hidden]': 'isPreview && !control.included'
  },
  template: `
    <mat-checkbox
      *ngIf="!isPreview"
      color="primary"
      [disabled]="control.disabled"
      [(ngModel)]="control.included"
      (change)="onCheckboxChange($event)"></mat-checkbox>

    <ng-content></ng-content>
  `,
  imports: [CommonModule, MatCheckboxModule, FormsModule],
  styleUrls: ['./checkbox-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckboxWrapperComponent {
  @Input() isPreview: boolean;

  protected control: DynamicFormControl;

  @ContentChild(NgControl) set wrappedControl(ngControl: NgControl) {
    this.control = ngControl.control as DynamicFormControl;
  }

  public onCheckboxChange({checked}: MatCheckboxChange) {
    this.control.included = checked;
  }
}
